import React from 'react'
import { ActionButton, ConnectionStatus, StatusDot, ConnectedEmail, ButtonGroup, LoadingSpinner } from '../style'

interface GoogleDriveConnectionButtonProps {
  isConnected: boolean
  email?: string
  isLoading: boolean
  onConnect: () => void
  onDisconnect: () => void
}

export const GoogleDriveConnectionButton: React.FC<GoogleDriveConnectionButtonProps> = ({
  isConnected,
  email,
  isLoading,
  onConnect,
  onDisconnect
}) => {
  if (isLoading) {
    return <LoadingSpinner />
  }

  if (isConnected) {
    return (
      <ButtonGroup>
        <ConnectionStatus connected>
          <StatusDot connected />
          Connected
          {email && <ConnectedEmail>({email})</ConnectedEmail>}
        </ConnectionStatus>
        <ActionButton variant="danger" onClick={onDisconnect}>
          Disconnect
        </ActionButton>
      </ButtonGroup>
    )
  }

  return (
    <ActionButton onClick={onConnect}>
      Connect Google Drive
    </ActionButton>
  )
}
